import { render, staticRenderFns } from "./ShopButton.vue?vue&type=template&id=1c1892a4&"
import script from "./ShopButton.vue?vue&type=script&lang=js&"
export * from "./ShopButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports